// extracted by mini-css-extract-plugin
export default {"MobileLayout":"MobileLayout_MobileLayout__DLNya"};